import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {currentUserStore} from '../../../../../api/user';
import {getCourseLabel} from '../../../../../utils/entity/course';
import {Currency, getPriceString} from '../../../../../utils/money';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {course, payment, program, user} = contexts;

  const data: EventData = {};

  if (payment) {
    const courseLabel = getCourseLabel(course);

    data.avatar = program?.avatar;
    data.avatarPlaceholder = program?.title;

    data.subAvatar = user?.avatar;
    data.subAvatarPlaceholder = user?.name;

    const transfer = payment.transfers[currentUserStore.user?._id || ''];

    data.title = i18n.t('notifications:payment_transferred.title', {
      courseDates: courseLabel ? `(${courseLabel})` : '',
      courseTitle: program?.title,
      price: getPriceString({
        currency: Currency[payment.currency],
        price: transfer?.amount || 0,
      }),
      userName: user?.name,
    });
  }

  return data;
};
